export function isInputField(field) {
  return Boolean(field.target);
}
export function isNestedFormField(field) {
  const nestedFormField = field;
  return Boolean(nestedFormField.target && nestedFormField.properties.nestedFormId);
}
//# sourceMappingURL=form-view.js.map